export const totalPatientPopulationData = [
  { value: 1, title: '< 10,000' },
  { value: 2, title: '10,001 - 50,000' },
  { value: 3, title: '50,001 - 250,000' },
  { value: 4, title: '250,001 - 1,000,000' },
  { value: 5, title: '> 1,000,000' },
];

export const primaryPatientPopulationData = [
  { value: 1, title: 'Addiction Medicine', selected: false },
  { value: 2, title: 'Adolescent Mediscine', selected: false },
  { value: 3, title: 'Adult Psychiatry', selected: false },
  { value: 4, title: 'Aerospace Medicine', selected: false },
  { value: 5, title: 'Allergy/Immunology', selected: false },
  { value: 6, title: 'Allergy Medicine', selected: false },
  { value: 7, title: 'Anesthesiology', selected: false },
  { value: 8, title: 'Bariatric Surgery', selected: false },
  { value: 9, title: 'Behavioral Mediine', selected: false },
  { value: 10, title: 'Breast Surgery', selected: false },
  { value: 11, title: 'Cardiac Electrophysiology', selected: false },
  { value: 12, title: 'Cardiac Surgery', selected: false },
  { value: 13, title: 'Cardiology', selected: false },
  { value: 14, title: 'Cardiothoracic Surgery', selected: false },
  { value: 15, title: 'Child Psychiatry', selected: false },
  { value: 16, title: 'Colorectal Surgery', selected: false },
  { value: 17, title: 'Cosmetic Surgery', selected: false },
  { value: 18, title: 'Critical Care Medicine', selected: false },
  { value: 19, title: 'Critical Care Pediatrics', selected: false },
  { value: 20, title: 'Dental & Oral Care', selected: false },
  { value: 21, title: 'Dermatology', selected: false },
  { value: 22, title: 'Dermapathology', selected: false },
  { value: 23, title: 'Diabetology', selected: false },
  { value: 24, title: 'Diagnostic Radiology', selected: false },
  { value: 25, title: 'Emergency Medicine', selected: false },
  { value: 26, title: 'Endocrinology', selected: false },
  { value: 27, title: 'ENT/Otolaryngology', selected: false },
  { value: 28, title: 'Epileptology', selected: false },
  { value: 29, title: 'Family Medicine', selected: false },
  { value: 30, title: 'Foot & Ankle Orthopedics', selected: false },
  { value: 31, title: 'Functional Medicine', selected: false },
  { value: 32, title: 'Gastroenterology', selected: false },
  { value: 33, title: 'General Medicine', selected: false },
  { value: 34, title: 'General Practice', selected: false },
  { value: 35, title: 'General Surgery', selected: false },
  { value: 36, title: 'Geriatrics', selected: false },
  { value: 37, title: 'Gynecologic Oncology', selected: false },
  { value: 38, title: 'Gynecology', selected: false },
  { value: 39, title: 'Hand Surgery', selected: false },
  { value: 40, title: 'Head & Neck Surgery', selected: false },
  { value: 41, title: 'Hematology', selected: false },
  { value: 42, title: 'Hematology/Oncology', selected: false },
  { value: 43, title: 'Heatology', selected: false },
  { value: 44, title: 'Holistic Medicine', selected: false },
  { value: 45, title: 'Immunology', selected: false },
  { value: 46, title: 'Infectious Disease', selected: false },
  { value: 47, title: 'Internal Medicine', selected: false },
  { value: 48, title: 'Internal Medicine/Pediatrics', selected: false },
  { value: 49, title: 'Interventional Cardiology', selected: false },
  { value: 50, title: 'Intervention Pain Management', selected: false },
  { value: 51, title: 'Medical Genetics', selected: false },
  { value: 52, title: 'Neonatology', selected: false },
  { value: 53, title: 'Nephrology', selected: false },
  { value: 54, title: 'Neurology', selected: false },
  { value: 55, title: 'Neuroradiology', selected: false },
  { value: 56, title: 'Neurosurgery', selected: false },
  { value: 57, title: 'Nuclear Cardiology', selected: false },
  { value: 58, title: 'Nuclear Medicine', selected: false },
  { value: 59, title: 'Nursing', selected: false },
  { value: 60, title: 'OBGYN/Obstetrics & Gynecology', selected: false },
  { value: 61, title: 'Obstetrics', selected: false },
  { value: 62, title: 'Obstetrics & Gynecology', selected: false },
  { value: 63, title: 'Occupational Medicine', selected: false },
  { value: 64, title: 'Oncology', selected: false },
  { value: 65, title: 'Opthalmology', selected: false },
  { value: 66, title: 'Orthopedic Surgery', selected: false },
  { value: 67, title: 'Osteopathic Medicine', selected: false },
  { value: 68, title: 'Otolaryngology', selected: false },
  { value: 69, title: 'Palliative Care', selected: false },
  { value: 70, title: 'Pathology', selected: false },
  { value: 71, title: 'Pediatric Neurology', selected: false },
  { value: 72, title: 'Pediatric Radiology', selected: false },
  { value: 73, title: 'Pediatric Surgery', selected: false },
  { value: 74, title: 'Pediatrics', selected: false },
  { value: 75, title: 'Pharmacy', selected: false },
  { value: 76, title: 'Physiatrist', selected: false },
  { value: 77, title: 'Physical Medicine & Rehabilitation', selected: false },
  { value: 78, title: 'Plastic Surgery', selected: false },
  { value: 79, title: 'Podiatry', selected: false },
  { value: 80, title: 'Preventive Medicine', selected: false },
  { value: 81, title: 'Psychiatry', selected: false },
  { value: 82, title: 'Pulmonary Critical Care', selected: false },
  { value: 83, title: 'Pulmonology', selected: false },
  { value: 84, title: 'Radiation Oncology', selected: false },
  { value: 85, title: 'Radiology', selected: false },
  { value: 86, title: 'Reconstructive Orthopaedic Surgery', selected: false },
  { value: 87, title: 'Rheumatology', selected: false },
  { value: 88, title: 'Sleep Medicine', selected: false },
  { value: 89, title: 'Sports Medicine', selected: false },
  { value: 90, title: 'Surgery - General', selected: false },
  { value: 91, title: 'Surgical Oncology', selected: false },
  { value: 92, title: 'Thoracic Surgery', selected: false },
  { value: 93, title: 'Transplant Surgery', selected: false },
  { value: 94, title: 'Traume Surgery', selected: false },
  { value: 95, title: 'Urgent Care', selected: false },
  { value: 96, title: 'Urogynecology', selected: false },
  { value: 97, title: 'Urology', selected: false },
  { value: 98, title: 'Vascular & Interventional Radiology', selected: false },
  { value: 99, title: 'Vascular Surgery', selected: false },
];

export const numberOfPatientsTreatedAnnuallyData = [
  { value: 1, title: '< 10,000' },
  { value: 2, title: '10,001 - 50,000' },
  { value: 3, title: '50,001 - 250,000' },
  { value: 4, title: '250,001 - 1,000,000' },
  { value: 5, title: '> 1,000,000' },
];

export const numberOfNewlyDiagnosedPatientsAnnuallyData = [
  { value: 1, title: '< 5,000' },
  { value: 2, title: '5,001 - 25,000' },
  { value: 3, title: '25,001 - 50,000' },
  { value: 4, title: '50,001 - 250,000' },
  { value: 5, title: '> 250,000' },
];

export const numberOfPatientsOnTrialData = [
  { value: 1, title: '< 100' },
  { value: 2, title: '101 - 1,000' },
  { value: 3, title: '1,001 - 10,000' },
  { value: 4, title: '> 10,000' },
];

export const numberOfCompassionateUsePatientsTreatedAnnuallyData = [
  { value: 1, title: '< 10' },
  { value: 2, title: '11 - 50' },
  { value: 3, title: '51 - 100' },
  { value: 4, title: '101 - 250' },
  { value: 5, title: '> 250' },
];

export const profileTypeList = [
  { title: 'Complete profile', value: '1' },
  { title: 'Partial profile', value: '2' },
];
